export default __webpack_public_path__ + "static/media/MainLogo.30de5c7e.png";